import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CONSENT_KEY = 'cardlockr_cookie_consent';
const ff = "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif";

export function getCookieConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [analytics, setAnalytics] = useState(true);

  useEffect(() => {
    const consent = getCookieConsent();
    if (!consent) setVisible(true);
  }, []);

  const save = (analyticsEnabled) => {
    const consent = { analytics: analyticsEnabled, savedAt: Date.now() };
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      background: '#1a1d27', borderTop: '1px solid rgba(255,255,255,0.1)',
      boxShadow: '0 -4px 24px rgba(0,0,0,0.3)',
      fontFamily: ff,
    }}>
      {!showDetails ? (
        /* Compact bar */
        <div style={{
          maxWidth: 1140, margin: '0 auto', padding: '16px 24px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          gap: 16, flexWrap: 'wrap',
        }}>
          <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.875rem', margin: 0, lineHeight: 1.5, flex: 1, minWidth: 200 }}>
            We use cookies to keep you logged in and, with your consent, to improve the product with anonymous analytics.{' '}
            <Link to="/cookies" style={{ color: '#818cf8', textDecoration: 'underline' }}>Cookie Policy</Link>
            {' · '}
            <Link to="/privacy" style={{ color: '#818cf8', textDecoration: 'underline' }}>Privacy Policy</Link>
          </p>
          <div style={{ display: 'flex', gap: 10, flexShrink: 0, flexWrap: 'wrap' }}>
            <button
              onClick={() => setShowDetails(true)}
              style={{
                background: 'transparent', color: 'rgba(255,255,255,0.5)', border: '1px solid rgba(255,255,255,0.2)',
                borderRadius: 7, padding: '8px 16px', fontSize: '0.84rem', cursor: 'pointer', fontFamily: ff,
              }}
            >
              Manage Preferences
            </button>
            <button
              onClick={() => save(false)}
              style={{
                background: 'transparent', color: 'rgba(255,255,255,0.6)', border: '1px solid rgba(255,255,255,0.2)',
                borderRadius: 7, padding: '8px 16px', fontSize: '0.84rem', cursor: 'pointer', fontFamily: ff,
              }}
            >
              Reject Optional
            </button>
            <button
              onClick={() => save(true)}
              style={{
                background: '#4F46E5', color: 'white', border: 'none',
                borderRadius: 7, padding: '8px 20px', fontSize: '0.84rem', fontWeight: 600, cursor: 'pointer', fontFamily: ff,
              }}
            >
              Accept All
            </button>
          </div>
        </div>
      ) : (
        /* Expanded preferences panel */
        <div style={{ maxWidth: 680, margin: '0 auto', padding: '28px 24px' }}>
          <h3 style={{ color: 'white', fontWeight: 700, fontSize: '1.05rem', margin: '0 0 6px' }}>Cookie Preferences</h3>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.84rem', margin: '0 0 24px', lineHeight: 1.5 }}>
            Choose which cookies you allow. Essential cookies are always active.
          </p>

          {/* Essential */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '14px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
            <div style={{ flex: 1, paddingRight: 16 }}>
              <div style={{ color: 'white', fontWeight: 600, fontSize: '0.9rem', marginBottom: 4 }}>Essential</div>
              <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.82rem', lineHeight: 1.5 }}>
                Authentication tokens, language & theme preferences. Required for the app to work.
              </div>
            </div>
            <div style={{
              background: '#22c55e', color: 'white', borderRadius: 20, padding: '4px 12px',
              fontSize: '0.75rem', fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0,
            }}>
              Always On
            </div>
          </div>

          {/* Analytics */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '14px 0', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
            <div style={{ flex: 1, paddingRight: 16 }}>
              <div style={{ color: 'white', fontWeight: 600, fontSize: '0.9rem', marginBottom: 4 }}>Analytics</div>
              <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.82rem', lineHeight: 1.5 }}>
                Anonymous usage data via PostHog. Helps us understand which features are used most. No personal data is shared.
              </div>
            </div>
            <label style={{ position: 'relative', display: 'inline-block', width: 44, height: 24, flexShrink: 0, cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={analytics}
                onChange={e => setAnalytics(e.target.checked)}
                style={{ opacity: 0, width: 0, height: 0, position: 'absolute' }}
              />
              <span style={{
                position: 'absolute', inset: 0, borderRadius: 12,
                background: analytics ? '#4F46E5' : 'rgba(255,255,255,0.2)',
                transition: 'background 0.2s',
              }} />
              <span style={{
                position: 'absolute', top: 3, left: analytics ? 23 : 3,
                width: 18, height: 18, borderRadius: '50%', background: 'white',
                transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
              }} />
            </label>
          </div>

          <div style={{ display: 'flex', gap: 10, marginTop: 20, justifyContent: 'flex-end' }}>
            <button
              onClick={() => setShowDetails(false)}
              style={{
                background: 'transparent', color: 'rgba(255,255,255,0.5)', border: '1px solid rgba(255,255,255,0.15)',
                borderRadius: 7, padding: '8px 16px', fontSize: '0.84rem', cursor: 'pointer', fontFamily: ff,
              }}
            >
              Back
            </button>
            <button
              onClick={() => save(analytics)}
              style={{
                background: '#4F46E5', color: 'white', border: 'none',
                borderRadius: 7, padding: '8px 20px', fontSize: '0.84rem', fontWeight: 600, cursor: 'pointer', fontFamily: ff,
              }}
            >
              Save Preferences
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
